import React from 'react';

const Logo = ({ className = "", width = "180" }) => {
  return (
    <div className={`matrix-logo ${className}`} style={{ width: `${width}px` }}>
      <img 
        src="/assets/matrix-logo.svg" 
        alt="Matrix Print Logo" 
        style={{ width: '100%', height: 'auto' }}
      />
    </div>
  );
};

export default Logo;
